import './index.css'
import cn from 'clsx'
import * as React from 'react'
import type { GROUP_TYPE } from '@disco/constants/GroupTypes'
import { BRIEFS, INBOX_TYPES } from '@disco/constants/GroupTypes'
import type { PaneType } from '@disco/constants/PaneTypes'
type Props = {
  type: PaneType | GROUP_TYPE
}

const EmptyIcon = ({ type }: Props): React.ReactElement<'div'> => {
  const noItemsIcon = cn('ExplorerPane_NoItemsIcon', {
    LibraryIcon: type === 'searchResults',
    PlaylistIcon: type === 'playlist',
    TrackIcon: type === 'track',
    BriefsIcon: type === BRIEFS,
    InboxIcon: INBOX_TYPES.includes(type),
  })
  return <div className={noItemsIcon} />
}

export default EmptyIcon
